export const educationFrag = `
    id
    name
    mpsvId
    description
`;

export const employmentTypeEducationFrag = `
    id
    employmentType
    educationId
`;
